<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Район
        .form-elem__main
          .input {{area}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Адрес
        .form-elem__main
          .input {{schoolAddress}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title {{schoolNameTitle}}
        .form-elem__main
          .input {{schoolName}}

</template>

<script>
export default {
  name: "request-education",
  props: {
    area: {
      type: String,
      default: "",
    },
    schoolAddress: {
      type: String,
      default: "",
    },
    schoolName: {
      type: String,
      default: "",
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    schoolNameTitle() {
      if (this.isAccompanying) {
        return "Место работы";
      } else {
        return "Школа или лицей";
      }
    },
  },
};
</script>
